import React from 'react'
import cn from 'classnames'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { find, get, isEmpty } from 'lodash';

import { getOrderInProgress, makeGetOrder } from '../selectors/order'
import { USE_RICH_CHECKOUT } from '../constants'
import ReceiptCard from '../components/receipt/ReceiptCard'
import QRCodeReceipt from '../containers/receipt/QRCodeReceipt'
import { clearCart } from '../actions/cart'
import { clearPromotionsOnOrder } from '../actions/promotion'
import { ReactComponent as CloseIcon } from '../assets/icons/sidebar-modal-close.svg'

import styles from './Receipt.module.scss'

const Receipt = ({ className, orderNumber, richCheckoutEnabled, onDone, hasBalanceDueInCents }) => {
  const classNames = cn(styles.receipt, className)
  const mediaQuery = window.matchMedia("(max-width: 450px)")

  const richCheckoutDisclaimer = richCheckoutEnabled ? (
    <div className={styles.disclaimer}>
      Discounts and gratuity applied from mobile purchases are not included.
      Please check your mobile receipt for final total.
    </div>
  ) : null
  return (
    <div className={classNames}>
      <div className={styles.receiptContent}>
        {mediaQuery?.matches && (
        <div className={styles.receiptContentHeader}>
          <div className={styles.receiptContentTitle}>Receipt</div>
          <CloseIcon onClick={() => onDone(hasBalanceDueInCents)}/>
        </div>
        )}
        <span className={styles.separator}/>
        <div className={styles.orderNumberWrapper}>
          <div className={styles.orderNumber}>{orderNumber}</div>
        </div>
        <ReceiptCard className={styles.receiptCard} richCheckoutEnabled={richCheckoutEnabled} mediaQuery={mediaQuery} />
        {!mediaQuery?.matches && richCheckoutDisclaimer}
      </div>
    
      <div className={styles.receiptQr}>
        <QRCodeReceipt className={styles.qrCodeReceipt}/>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const orderUuid = get(ownProps, 'match.params.orderUuid', undefined)
  const richCheckoutEnabled = USE_RICH_CHECKOUT === 'true'
  const paymentId = ownProps?.match?.params?.paymentId
  const getOrder = makeGetOrder()
  let order = {}
  let orderNumber
  let hasBalanceDueInCents = false

  if (paymentId) {
    const orderInProgress = getOrderInProgress(state)
    order = !isEmpty(orderInProgress) ? orderInProgress : getOrder(state, orderUuid)
    orderNumber = find(order.payments,(payment) => payment.paymentId === paymentId)?.orderNumber
    hasBalanceDueInCents = order.balanceDueInCents !== 0
  } else {
    order = orderUuid ? getOrder(state, orderUuid) : getOrder(state, state.order.currentOrderId)
    orderNumber = order?.orderNumber
  }

  return { orderNumber, richCheckoutEnabled, hasBalanceDueInCents }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const push = get(ownProps, 'history.push', () => {})

  return {
    onDone: (hasBalanceDueInCents) => {
      if (hasBalanceDueInCents) {
        push('/split-tender')
      } else {
        dispatch(clearCart())
        dispatch(clearPromotionsOnOrder())
        push('/concession-order')
      }
    }
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Receipt))
